export default "<div class=\"signing-in\">\r\n  <app-empyrean-loader width=\"100\"></app-empyrean-loader>\r\n  <h3>Loading...</h3>\r\n</div>\r\n"